var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiblingPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H6C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3V12C4.5 12.3978 4.65804 12.7794 4.93934 13.0607C5.22064 13.342 5.60218 13.5 6 13.5H15C15.3978 13.5 15.7794 13.342 16.0607 13.0607C16.342 12.7794 16.5 12.3978 16.5 12V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5ZM10.5 3.375C10.9973 3.375 11.4742 3.57254 11.8258 3.92417C12.1775 4.27581 12.375 4.75272 12.375 5.25C12.375 5.74728 12.1775 6.22419 11.8258 6.57583C11.4742 6.92746 10.9973 7.125 10.5 7.125C10.0027 7.125 9.52581 6.92746 9.17417 6.57583C8.82254 6.22419 8.625 5.74728 8.625 5.25C8.625 4.75272 8.82254 4.27581 9.17417 3.92417C9.52581 3.57254 10.0027 3.375 10.5 3.375ZM14.25 11.25H6.75V11.0625C6.75 9.67575 8.4405 8.25 10.5 8.25C12.5595 8.25 14.25 9.67575 14.25 11.0625V11.25Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H1.5V15C1.5 15.8273 2.17275 16.5 3 16.5H12V15H3V6Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiblingPurple);
export default __webpack_public_path__ + "static/media/sibling_purple.048b63d684ab92a391e19e7d35eb9622.svg";
export { ForwardRef as ReactComponent };